import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";



function MindMapPhysTopics() {



  return (
    <>

      <AllSubjectTopics  subject="physics" type="mindmap" />

    </>
  );
}

export default MindMapPhysTopics;